import debounce from 'lodash.debounce';
import {
  trackMarkerHover as trackHover,
  trackMarkerClick as trackClick,
} from '../spatialTracking';

/**
 * EEN uses DeckGL which repaints hovers in every frame refresh
 * which happens repeatedly during a hover event, this function
 * makes sure to debounce calls to the same hover event.
 */
export const trackMarkerHover = debounce(spatialLayerKey => {
  trackHover(spatialLayerKey);
}, 500);

/**
 * Track clicks, debounced to avoid recording double clicking.
 */
export const trackMarkerClick = debounce(spatialLayerKey => {
  trackClick(spatialLayerKey);
}, 500);
